import React from 'react';
import { ApButtonText } from '@alixpartners/ui-components';
import { AgGridReact } from 'ag-grid-react';
import 'ag-grid-community/dist/styles/ag-grid.css';

import { ICurrencyFormat, ITableRow } from 'utils/types';
import { useTableData } from './TopVendorsTable.helpers';
import { TableHeader, TableHeaderGroup } from '../TableComponents';
import { Pagination, TableWrapper } from '../Table.styles';
import { Container } from './TopVendorsTable.styles';
import { HEADER_HEIGHT, ROW_HEIGHT } from '../table-utils';
import { GridReadyEvent } from 'ag-grid-community';

export const TopVendorsTable = ({
  columns,
  columnDateLabels,
  format,
  rowData,
  pageSize = 10,
  totalRow,
}: {
  columns: string[];
  columnDateLabels: string[];
  format: ICurrencyFormat;
  rowData: ITableRow[];
  pageSize?: number;
  totalRow?: ITableRow;
}) => {
  const [gridApi, setGridApi] = React.useState<any>(null);
  const [extraRows, setExtraRows] = React.useState(0);
  const { columnDefs } = useTableData({
    columns,
    columnDateLabels,
    format,
  });
  const paginationPageSize = pageSize * (extraRows + 1);
  const displayedRowData = rowData.slice(0, pageSize * (extraRows + 1));

  const gridOptions = {
    columnDefs: columnDefs,
    defaultColDef: { width: 56 },
    rowData,
    rowHeight: ROW_HEIGHT,
    headerHeight: HEADER_HEIGHT,
  };

  return (
    <Container>
      <TableWrapper className="ag-theme-balham">
        <AgGridReact
          {...gridOptions}
          frameworkComponents={{
            customHeaderGroupComponent: TableHeaderGroup,
            agColumnHeader: TableHeader,
          }}
          onGridReady={(event: GridReadyEvent) => {
            setGridApi(event.api);
            event.api.paginationSetPageSize(paginationPageSize);
          }}
          pinnedTopRowData={[totalRow]}
          suppressCopyRowsToClipboard
          suppressScrollOnNewData
          suppressRowHoverHighlight
          suppressRowDrag
          suppressRowClickSelection
          suppressCellSelection
          suppressCsvExport
          suppressExcelExport
          suppressContextMenu
          domLayout="autoHeight"
          paginationPageSize={paginationPageSize}
          paginationAutoPageSize={true}
          pagination={true}
          suppressPaginationPanel={true}
        />
      </TableWrapper>
      <Pagination>
        {displayedRowData.length}/{rowData.length}
        {displayedRowData.length !== rowData.length && (
          <ApButtonText
            onClick={() => {
              const currentPageSize = gridApi.paginationGetPageSize();
              gridApi.paginationSetPageSize(currentPageSize + pageSize);
              setExtraRows(extraRows + 1);
            }}
          >
            SHOW MORE...
          </ApButtonText>
        )}
      </Pagination>
    </Container>
  );
};

export default TopVendorsTable;
